import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InfoBannerComponent } from '@app/shared/components/info-banner/info-banner.component';
import { LoaderComponent } from '@app/shared/components/loader/loader.component';
import { NoDataLabelComponent } from '@app/shared/components/no-data-label/no-data-label.component';
import { DatePickerComponent } from '@app/shared/components/date-picker/date-picker.component';
import { GlobalCurrencyPipe } from '@app/shared/pipes/global-currency.pipe';
import {
  GenericLineChartComponent,
} from '@app/shared/components/charts/generic-line-chart/generic-line-chart.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NavigationComponent } from '@app/shared/components/navigation/navigation.component';
import { NavigationPermissionsHelper } from '@app/shared/components/navigation/helpers/navigation-permissions.helper';
import {
  GenericStackedBarChartComponent,
} from '@app/shared/components/charts/generic-stacked-bar-chart/generic-stacked-bar-chart.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import {
  DatePresetsSelectorComponent,
} from '@app/shared/components/date-presets-selector/date-presets-selector.component';
import {
  GenericMixedChartComponent,
} from '@app/shared/components/charts/generic-mixed-chart/generic-mixed-chart.component';
import { ChartHelper } from '@app/shared/components/charts/helpers/chart.helper';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';

export const materialModules = [
  MatSelectModule,
  MatFormFieldModule,
  MatCardModule,
  MatProgressBarModule,
  MatListModule,
  MatInputModule,
  MatIconModule,
  MatMenuModule,
  MatAutocompleteModule,
  MatRadioModule,
  MatSlideToggleModule,
  MatCheckboxModule,
  MatButtonModule,
  MatChipsModule,
];

const modules = [
  TranslateModule,
  CommonModule,
  ReactiveFormsModule,
  FormsModule,
  ...materialModules,
];

const components = [
  InfoBannerComponent,
  LoaderComponent,
  NoDataLabelComponent,
  DatePickerComponent,
  GlobalCurrencyPipe,
  GenericLineChartComponent,
  GenericMixedChartComponent,
  NavigationComponent,
  GenericStackedBarChartComponent,
  DatePresetsSelectorComponent,
];

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    ...modules,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxDaterangepickerMd,
  ],
  declarations: [...components, GenericLineChartComponent],
  providers: [NavigationPermissionsHelper, ChartHelper],
  exports: [...modules, ...components, GenericLineChartComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
}
